// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/@rsbuild+core@1.3.19/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cascader[data-v-4590155e] {\n  line-height: 1;\n  position: relative;\n}\n.cascader .closeIcon[data-v-4590155e] {\n  cursor: pointer;\n  color: #999;\n  position: absolute;\n  top: 10px;\n  right: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
